import {
	IFavouriteFilterGroupModel ,
	IFavouriteFilterModel ,
	IFavouriteFilterRequestModel
} from "./../../models/favourite-filter/favourite-filter-model";
import {MutationTree} from "vuex";
import {IFavouriteFilterState} from "./favourite-filter-states.store";
import favouriteFilterTypesStore from "./favourite-filter-types.store";
import moduleConstant from "../../common/module-constant";

const favouriteMutations: MutationTree<IFavouriteFilterState> = <
	MutationTree<IFavouriteFilterState>
	>{
	/**
	 * MUTATION: STORED LIST
	 */
	[favouriteFilterTypesStore.Mutation.UPDATE_LIST_FAVOURITES]: (
		state: IFavouriteFilterState ,
		data: IFavouriteFilterGroupModel[]
	) => {
		state.favouriteFilters = data;
	},
	
	// Property
	[favouriteFilterTypesStore.Mutation.UPDATE_LIST_PROPERTY_FAVOURITES]: (
		state: IFavouriteFilterState,
		data: IFavouriteFilterGroupModel[]
	) => {
		state.propertyfavouriteFilters = data;
	},

	// Person
	[favouriteFilterTypesStore.Mutation.UPDATE_LIST_PERSON_FAVOURITES]: (
		state: IFavouriteFilterState,
		data: IFavouriteFilterGroupModel[]
	) => {
		state.personfavouriteFilters = data;
	},

	// Demand
	[favouriteFilterTypesStore.Mutation.UPDATE_LIST_DEMAND_FAVOURITES]: (
		state: IFavouriteFilterState,
		data: IFavouriteFilterGroupModel[]
	) => {
		state.demandfavouriteFilters = data;
	},

	// Task
	[favouriteFilterTypesStore.Mutation.UPDATE_LIST_TASK_FAVOURITES]: (
		state: IFavouriteFilterState,
		data: IFavouriteFilterGroupModel[]
	) => {
		state.taskfavouriteFilters = data;
	},
	
	[favouriteFilterTypesStore.Mutation.UPDATE_CURRENT_FAVOURITE]: (
		state: IFavouriteFilterState ,
		data: IFavouriteFilterModel
	) => {
        let moduleName = '';
        let leastConditionForSidebar = {};
		switch (data.Type) {
			case moduleConstant.Object:
                moduleName = 'currentPropertyFavourite'
                leastConditionForSidebar = {
                    StatusIds: [],
                    PurposeIds: [],
                    ConstructionTypes: [],
                    SiteIds: []
                };
                
				break;
			case moduleConstant.Person:
                moduleName = 'currentPersonFavourite'
                leastConditionForSidebar = {
                    Category1Ids: [],
                    StatusIds: [],
                    SiteIds: []
                };
				break;
			case moduleConstant.Demand:
                moduleName = 'currentDemandFavourite'
                leastConditionForSidebar = {
                    StatusIds: [],
                    PurposeIds: [],
                    GoalIds: [],
                    SiteIds: []
                };
				break;
			case moduleConstant.Task:
                moduleName = 'currentTaskFavourite'
                leastConditionForSidebar = {
                    TaskGroupIds: [],
                };
				break;
			default:
				break;
        }
        if (data.Condition) {
            Object.keys(leastConditionForSidebar).forEach(key => {
                if(data.Condition[key] === undefined) {
                    data.Condition[key] = leastConditionForSidebar[key];
                }
            });
        }

		Object.keys(data).forEach(key => {
			if (data[key] != null) state[moduleName][key] = data[key];
		});
  },
  
  [favouriteFilterTypesStore.Mutation.UPDATE_ORIGINAL_FAVOURITE]: (
    state: IFavouriteFilterState,
    data: IFavouriteFilterModel
  ) => {
    let moduleName = '';
    let leastConditionForSidebar = {};
    switch (data.Type) {
      case moduleConstant.Object:
        moduleName = 'originalPropertyFavourite';
        leastConditionForSidebar = {
            StatusIds: [],
            PurposeIds: [],
            ConstructionTypes: [],
            SiteIds: []
        };
        break;
      case moduleConstant.Person:
        moduleName = 'originalPersonFavourite';
        leastConditionForSidebar = {
            Category1Ids: [],
            StatusIds: [],
            SiteIds: []
        };

        break;
      case moduleConstant.Demand:
        moduleName = 'originalDemandFavourite';
        leastConditionForSidebar = {
            StatusIds: [],
            PurposeIds: [],
            GoalIds: [],
            SiteIds: []
        };
        break;
      case moduleConstant.Task:
        moduleName = 'originalTaskFavourite';
        leastConditionForSidebar = {
            TaskGroupIds: [],
        };
        break;
      default:
        break;
    }

    if (data.Condition) {
        Object.keys(leastConditionForSidebar).forEach(key => {
            if(data.Condition[key] === undefined) {
                data.Condition[key] = leastConditionForSidebar[key];
            }
        });
    }

    Object.keys(data).forEach(key => {
      if (data[key] != null) state[moduleName][key] = data[key];
    });
  },
	
	/**
	 * MUTATION: STORED CURRENT SELECTED FAVOURITE
	 */
	[favouriteFilterTypesStore.Mutation.RESET_CURRENT_FAVOURITE]: (
		state: IFavouriteFilterState ,
		data: IFavouriteFilterModel
	) => {
		switch (data.Type) {
			case moduleConstant.Object:
        state.currentPropertyFavourite = data;
				break;
			case moduleConstant.Person:
				state.currentPersonFavourite = data;
				break;
			case moduleConstant.Demand:
				state.currentDemandFavourite = data;
				break;
			case moduleConstant.Task:
				state.currentTaskFavourite = data;
				break;
			default:
				state.currentFavourite = data;
				break;
		}
	} ,
	
	/**
	 * MUTATION: STORED CURRENT REQUEST MODEL
	 */
	[favouriteFilterTypesStore.Mutation.UPDATE_CURRENT_REQUEST_MODEL]: (
		state: IFavouriteFilterState ,
		data: IFavouriteFilterRequestModel
	) => {
		Object.keys(data).forEach(key => {
			state.currentRequestModel[key] = data[key];
		});
	} ,
	[favouriteFilterTypesStore.Mutation.UPDATE_DEFAULT_FAVOURITE]: (state: IFavouriteFilterState, payload: IFavouriteFilterModel) => {
		let moduleName = '';
		switch (payload.Type) {
			case moduleConstant.Object:
				moduleName = 'propertyfavouriteFilters'
				break;
			case moduleConstant.Person:
				moduleName = 'personfavouriteFilters'
				break;
			case moduleConstant.Demand:
				moduleName = 'demandfavouriteFilters'
				break;
			case moduleConstant.Task:
				moduleName = 'taskfavouriteFilters'
				break;
			default:
				break;
		}	
		let [first] = state[moduleName];
		let filters = first.Filters.map((item) => {
			if (item.Id === payload.Id) {
				item.IsDefault = true;
			} else {
				item.IsDefault = false;
			}
			return item;
		});
		state[moduleName][0] = {Filters: filters, UserId: first.UserId}
	}
};

export default favouriteMutations;
